'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _ChatHeadingConfigTypes = require('../constants/ChatHeadingConfigTypes');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UsersAndTeamsChatHeadingConfig = function (_Record) {
  _inherits(UsersAndTeamsChatHeadingConfig, _Record);

  function UsersAndTeamsChatHeadingConfig() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, UsersAndTeamsChatHeadingConfig);

    return _possibleConstructorReturn(this, (UsersAndTeamsChatHeadingConfig.__proto__ || Object.getPrototypeOf(UsersAndTeamsChatHeadingConfig)).call(this, (0, _immutable.fromJS)(options)));
  }

  return UsersAndTeamsChatHeadingConfig;
}((0, _immutable.Record)({
  '@type': _ChatHeadingConfigTypes.USERS_AND_TEAMS,
  userIds: (0, _immutable.List)(),
  teamIds: (0, _immutable.List)()
}, 'UsersAndTeamsChatHeadingConfig'));

exports.default = UsersAndTeamsChatHeadingConfig;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/records/UsersAndTeamsChatHeadingConfig.js
// module id = 337
// module chunks = 2 3